export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

export const insideItems: string[] = [
  'Forklift anatomy diagrams',
  'Forklift mast and carriage illustrations',
  'Industrial truck comparisons',
  'Load stability concepts',
  'Warehouse traffic layouts',
  'Excavator anatomy',
  'Hydraulic cylinder references',
  'Bucket and attachment illustrations',
  'Earthmoving equipment comparisons',
  'Excavation-site diagrams',
  'Bulldozer component references',
  'Wheel loader technical illustrations',
  'Motor grader anatomy',
  'Machinery identification boards',
  'Construction worksite maps',
  'Mobile crane anatomy',
  'Telescopic boom illustrations',
  'Hoist and lifting component references',
  'Rigging equipment identification',
  'Lifting-site hazard scenarios',
  'Scissor lift anatomy',
  'Articulating boom lift illustrations',
  'Telescopic platform references',
  'Elevated-worksite hazard recognition',
  'Road roller components',
  'Asphalt paver anatomy',
  'Compaction equipment comparisons',
  'Road construction layouts',
  'Technical matching exercises',
  'Machinery identification challenges',
  'Workplace observation activities',
  'Instructor assessment tools',
  'Quick-reference teaching sheets',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/qRwGoP26CAffkVFZywy2eB/Captura_de_pantalla_2026-10-19_230438.png',
    alt: 'Six specialized machinery atlases: forklift, excavator, dozer and loader, mobile crane, boom lift and road roller with component close-ups',
    title: 'Six Specialized Machinery Atlases',
    caption: 'Discover six major machinery specializations in one complete visual training library.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3PrHBtKJJ4kEdszupDb2JL/Captura_de_pantalla_2026-10-19_230321.png',
    alt: 'Hydraulic excavator anatomy page with numbered components: boom, stick, bucket, linkage, hydraulic cylinders, cab, counterweight and undercarriage',
    title: 'Hydraulic Excavator Anatomy',
    caption:
      'Explore detailed machinery components, hydraulic structures and professional technical illustrations.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oHmmmcZgChY1SKa5FR135P/Captura_de_pantalla_2026-10-19_230348.png',
    alt: 'Mobile crane technical atlas page with labeled telescopic boom, hoist line, hook block, cab, counterweight, carrier frame and outriggers',
    title: 'Mobile Crane Technical Atlas',
    caption: 'Examine crane anatomy, lifting-system components and technical equipment references.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8MPDGt9HLd8yrAnu96fSce/Captura_de_pantalla_2026-10-19_230416.png',
    alt: 'Identify height-related workplace hazards: elevated worksite cutaway with six numbered recognition points around scissor and boom lifts',
    title: 'Identify Height-Related Workplace Hazards',
    caption:
      'Explore realistic industrial scenarios designed for equipment safety awareness and hazard recognition.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hYYh5RaDa6TMPBU9vxQZLW/Captura_de_pantalla_2026-10-19_230458.png',
    alt: 'From machine diagrams to ready-to-teach activities: six instructor exercise panels for forklift, excavator, dozer, crane, aerial platform and road machinery',
    title: 'From Machine Diagrams to Ready-to-Teach Activities',
    caption:
      'Discover instructor-ready equipment identification exercises, technical comparisons and knowledge assessments.',
  },
]
